import { motion } from "framer-motion";
import { CalendarDays, Clock3, IdCard, MapPinned } from "lucide-react";

const FACTS = [
  {
    icon: CalendarDays,
    title: "General Election Day",
    text: "Tuesday, November 3, 2026. Mark it. Plan it. Bring a friend.",
  },
  {
    icon: Clock3,
    title: "Polls Open",
    text: "7:00 AM – 7:00 PM CT. If you're in line by 7 PM, you can vote.",
  },
  {
    icon: IdCard,
    title: "What To Bring",
    text: "Tribal ID or North Dakota ID. If your address isn't current, bring a document that shows it.",
  },
  {
    icon: MapPinned,
    title: "Where To Vote",
    text: "Polling places are set for each segment of the Fort Berthold Reservation. Final locations will be posted here as the Tribe announces them.",
  },
];

const DATES = [
  { date: "Nov 03", label: "GENERAL ELECTION DAY" },
];

export default function VoterInfo() {
  return (
    <section id="vote" className="relative bg-electric noise py-24 md:py-36 px-5 md:px-10 overflow-hidden" data-testid="voter-info-section">
      <div className="max-w-6xl mx-auto relative z-10">
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="text-xs uppercase tracking-[0.3em] font-semibold text-white/70 mb-6"
        >
          Voter Information
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="font-serif text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-white mb-16 md:mb-20"
        >
          Make a plan
          <span className="block italic font-medium text-white/90">to vote.</span>
        </motion.h2>

        <div className="grid sm:grid-cols-2 gap-px bg-white/25 border border-white/25 mb-16">
          {FACTS.map((f, i) => (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="bg-electric p-8 md:p-10"
              data-testid={`voter-fact-${i}`}
            >
              <f.icon className="w-7 h-7 text-gold mb-5" strokeWidth={1.5} />
              <h3 className="font-sans text-lg md:text-xl font-bold tracking-tight text-white mb-2">{f.title}</h3>
              <p className="text-white/80 text-sm md:text-base leading-relaxed">{f.text}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-40px" }}
          transition={{ duration: 0.8 }}
        >
          <h3 className="text-xs uppercase tracking-[0.3em] font-semibold text-white/70 mb-6">Key Dates</h3>
          <div className="divide-y divide-white/20 border-y border-white/20">
            {DATES.map((d) => (
              <div key={d.date + d.label} className="flex items-baseline gap-6 md:gap-10 py-4" data-testid={`key-date-${d.date.replace(/\s/g, "-")}`}>
                <span className="font-serif font-bold text-white text-lg md:text-xl w-20 shrink-0">{d.date}</span>
                <span className={`text-sm md:text-base ${d.label.includes("GENERAL") ? "font-bold text-white" : "text-white/85"}`}>
                  {d.label}
                </span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
